import React from "react";

const LegalStrip = ({ agent }) => (
  <div className="abr-legal-strip">
    <strong>{agent.fullName}</strong> &middot; {agent.brokerage} &middot; {agent.licenseLabel} &middot;{" "}
    {agent.mlsLabel} &middot; {agent.phoneDisplay}
  </div>
);

export default LegalStrip;
